export default {
	init() {
		// JavaScript to be fired on the about us page

		// Masthead carousel
		if ($('.masthead-carousel').length > 0) {
			var $slider = $('.masthead-carousel');

			$(document).ready(function () {
				setTimeout(() => {
					$slider.slick({
						slide: '.masthead-carousel .masthead-carousel__slide',
						autoplay: true,
						autoplaySpeed: 6000,
						infinite: true,
						cssEase: 'ease',
						slidesToShow: 1,
						slidesToScroll: 1,
						swipeToSlide: true,
						pauseOnFocus: false,
						pauseOnHover: false,
						fade: true,
						dots: true,
						arrows: true,
						speed: 50,
						rows: 0,
						nextArrow:
							'<button type="button" class="slick-next"><span class="screen-reader-text">Next</span><i class="icon-arrow-right"></i></button>',
						prevArrow:
							'<button type="button" class="slick-prev"><span class="screen-reader-text">Previous</span><i class="icon-arrow-left"></i></button>',
					});

					// Adjust right arrow so it aligns next to dots
					let $slickDots = $('.slick-dots li');
					let $slickRightArrow = $('.slick-next');
					if ($slickDots && $slickRightArrow) {
						let $slickCount = $slickDots.length;
						let $slickDotWidth = $($slickDots[0]).outerWidth(true);
						// console.log(slickDotWidth);
						$slickRightArrow.css(
							'left',
							$slickDotWidth * $slickCount + 37 + 'px'
						);
					}
				}, 1000);

				// eslint-disable-next-line no-unused-vars
				$slider.on('beforeChange', function (event, slick, direction) {
					// find current nav dot
					var $currentDot = $('.slick-dots .slick-active');
					$currentDot.addClass('prev-dot');
				});

				// remove classes once slide resets
				// eslint-disable-next-line no-unused-vars
				$slider.on(
					'beforeChange',
					function (event, slick, currentSlide) {
						if (slick.$slides.length - 1 == currentSlide) {
							var $dots = $('.slick-dots li');
							$dots.removeClass('prev-dot');
						}
					}
				);
			});
		}
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/about.js